import React, { useState, useEffect,useRef } from "react";
import { getAllCompaniesForSuperAdmin } from "../../services/api/SuperAdminApi";
import "./CompanySelectionModal.scss";

const CompanySelectionModal = ({ isOpen, onClose, onSelectCompany }) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCompanies, setFilteredCompanies] = useState([]);
  const modalRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      fetchCompanies();
    }
  }, [isOpen]);


    useEffect(() => {
      const handleClickOutside = (event) => {
  
        if (modalRef.current && !modalRef.current.contains(event.target)) {
          onClose();
        }
      };
  
      // Add event listener when the modal is open
      if (isOpen) {
        document.addEventListener("mousedown", handleClickOutside);
      }
  
      // Cleanup function to remove the event listener
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [isOpen, onClose])

  useEffect(() => {
    // Filter companies based on search query
    // Ensure companies is an array before filtering
    const companiesArray = Array.isArray(companies) ? companies : [];
    
    if (searchQuery.trim() === "") {
      setFilteredCompanies(companiesArray);
    } else {
      const filtered = companiesArray.filter((company) => {
        const nameMatch = company.companyName?.toLowerCase().includes(searchQuery.toLowerCase());
        const emailMatch = company.email && company.email.toLowerCase().includes(searchQuery.toLowerCase());
        
        return nameMatch || emailMatch;
      });
      setFilteredCompanies(filtered);
    }
  }, [companies, searchQuery]);

  const fetchCompanies = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getAllCompaniesForSuperAdmin();
      console.log('Companies API response:', response); // Debug log
      
      // Ensure we always get an array, handle different response structures
      let companiesData = [];
      if (response?.data?.result && Array.isArray(response.data.result)) {
        companiesData = response.data.result;
        console.log('Using response.data.result:', companiesData.length, 'companies'); // Debug log
      } else if (response?.data && Array.isArray(response.data)) {
        companiesData = response.data;
        console.log('Using response.data:', companiesData.length, 'companies'); // Debug log
      } else {
        console.log('No companies found in response or invalid structure'); // Debug log
      }
      
      setCompanies(companiesData);
      setFilteredCompanies(companiesData);
    } catch (err) {
      console.error("Error fetching companies:", err);
      setError("Failed to load companies");
      setCompanies([]);
      setFilteredCompanies([]);
    } finally {
      setLoading(false);
    }
  };

  const handleCompanySelect = (company) => {
    onSelectCompany(company);
    onClose();
    setSearchQuery(""); // Reset search
  };

  const handleClose = () => {
    onClose();
    setSearchQuery(""); // Reset search when closing
  };

  if (!isOpen) return null;

  return (
    <div className="company-selection-modal-overlay">
      <div ref={modalRef} className="company-selection-modal">
        <div className="modal-header">
          <h2>Select Company to Manage Cases</h2>
          <button className="close-btn" onClick={handleClose}>
            ×
          </button>
        </div>

        <div className="modal-body">
          {/* Search Input */}
          <div className="search-container">
            <input
              type="text"
              placeholder="Search companies by name or email..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
          </div>

          {loading && <div className="loading">Loading companies...</div>}

          {error && <div className="error">{error}</div>}

          {!loading && !error && (
            <div className="companies-list">
              {!Array.isArray(filteredCompanies) || filteredCompanies.length === 0 ? (
                <div className="no-companies">
                  {searchQuery.trim() ? "No companies found matching your search" : "No companies available"}
                </div>
              ) : (
                filteredCompanies.map((company, index) => (
                  <div
                    key={company._id || index}
                    className="company-item"
                    onClick={() => handleCompanySelect(company)}
                  >
                    <div className="company-info">
                      <h3 className="company-name">{company.companyName}</h3>
                      {company.email && (
                        <p className="company-email">{company.email}</p>
                      )}
                      {company.contactPersonName && (
                        <p className="contact-person">Contact: {company.contactPersonName}</p>
                      )}
                    </div>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CompanySelectionModal;
